import React from "react";
import { useRemoteMarkdownQuery } from "server/corsproxy/remoteContent/queries";
import { SafeMarkdown } from "./SafeMarkdown";

interface MarkdownViewerProps {
  markdownUrl: string;
}

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({ markdownUrl }) => {
  const {
    data: markdown,
    error,
    isInitialLoading,
  } = useRemoteMarkdownQuery(markdownUrl);

  if (isInitialLoading) {
    return (
      <div className="flex items-center justify-center p-8 text-white">
        Loading...
      </div>
    );
  }

  if (error || markdown === undefined) {
    return (
      <div>
        Error loading markdown:{" "}
        {error instanceof Error ? error.message : "Unknown error"}
      </div>
    );
  }

  return <SafeMarkdown baseUrl={markdownUrl}>{markdown}</SafeMarkdown>;
};

export default MarkdownViewer;
